import { createFileRoute } from "@tanstack/react-router";
import { CelebrityResultPage } from "@/components/site/CelebrityResultPage";
import { heathEvans } from "@/lib/celebrity-results/heath-evans";
import { absoluteUrl } from "@/lib/absolute-url";

const TITLE = "Heath Evans Hair Transplant Results | RESTORE® Hair";
const DESC = "See former NFL player Heath Evans' RESTORE® No-Shave FUE™ hair transplant results, before & after photos and his full hair restoration story.";
const POSTER = "/img/r/wp-2021-12-heath-hero-lg-1.webp";

export const Route = createFileRoute("/results/heath-evans")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "article" },
      { property: "og:url", content: "https://restorehair.com/results/heath-evans/" },
      { property: "og:image", content: absoluteUrl(POSTER) },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: absoluteUrl(POSTER) },
    ],
    links: [
      { rel: "canonical", href: "https://restorehair.com/results/heath-evans/" },
    ],
  }),
  component: () => <CelebrityResultPage data={heathEvans} />,
});
